import React from "react";
import { useSelector,useDispatch } from "react-redux";
import { IconButton, Badge, Tooltip } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import styled from "@emotion/styled";
import { fetchNotifications } from "../statemanagement/asyncThunkAPI";

/** styled component to show the count as badge */
const StyledBadge = styled(Badge)(() => ({
  "& .MuiBadge-badge": {
    fontSize: "0.65rem",
    height: 16,
    minWidth: 16,
  },
}));

/** styled component for the notification button */
const StyledNotificationsIcon = styled(NotificationsIcon)(() => ({
  fontSize: 26,
}));

/**
 * @author Aston Kingsley
 * In this component we are building the notification icon that will show the top header
 * @param {*} param0 
 * @returns 
 */
const NotificationIcon = ({ setAnchorEl }) => {
  const dispatch = useDispatch();
  const { count } = useSelector((state) => state.notificationData);

  /**
   * function to show the pop over it will open the pop over when the icon is clicked
   * @param {*} event 
   */
  const handleNotificationBarOpen = (event) => {
    setAnchorEl(event.currentTarget);
    dispatch(fetchNotifications());
  }

  return (
    <Tooltip title="Notifications">
      <IconButton color="inherit" onClick={(event) => handleNotificationBarOpen(event)}>
        <StyledBadge
          badgeContent={count > 0 ? count : null}
          color="error"
          overlap="circular"
        >
          <StyledNotificationsIcon />
        </StyledBadge>
      </IconButton>
    </Tooltip>
  );
};

export default NotificationIcon;
